import { s as subscribe } from "../../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import "../../../../chunks/customer2.js";
import { p as page } from "../../../../chunks/stores.js";
import "../../../../chunks/client.js";
import { S as Spinner } from "../../../../chunks/Spinner.js";
import { P as PageLayout } from "../../../../chunks/PageLayout.js";
import { S as SearchFilter } from "../../../../chunks/SearchFilter.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { data } = $$props;
  let search = $page.url.searchParams.get("search") || "";
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(PageLayout, "PageLayout").$$render($$result, { title: "Kunden" }, {}, {
      default: () => {
        return `<section>${validate_component(SearchFilter, "SearchFilter").$$render(
          $$result,
          { search },
          {
            search: ($$value) => {
              search = $$value;
              $$settled = false;
            }
          },
          {}
        )} ${`<div class="text-center my-5">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div>`}</section>`;
      }
    })}`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
